import React from 'react';
import YogaDay2024 from 'views/YogaDay2024/YogaDay2024';
const ExtraCurricularActivitiesPage = () => {
  return <YogaDay2024/>;
};

export default ExtraCurricularActivitiesPage;